import { render, staticRenderFns } from "./storeDecorationTemp.vue?vue&type=template&id=0bd004b7&scoped=true&"
import script from "./storeDecorationTemp.vue?vue&type=script&lang=js&"
export * from "./storeDecorationTemp.vue?vue&type=script&lang=js&"
import style0 from "./storeDecorationTemp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./storeDecorationTemp.vue?vue&type=style&index=1&id=0bd004b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd004b7",
  null
  
)

component.options.__file = "storeDecorationTemp.vue"
export default component.exports